import { localText, registerClass } from "@serenity-is/corelib";
import { AddonTextWithIcon } from "./AddonTextWithIcon";
import { EditorAddonUtils } from "./EditorAddonUtils";

export function InputGroupTextAddon(props: {
    text: string,
    addonKey?: string;
    before?: boolean,
    hint?: string,
    icon?: string,
    cssClass?: string,
    editorElement?: HTMLElement
}): HTMLElement {
    const { addonKey, cssClass, hint, icon, text, editorElement, before } = props;

    const addon = (
        <span class={["input-group-text", cssClass]} title={!!hint && localText(hint, hint)}
            data-addonkey={!!addonKey && addonKey} data-addonfor={!!editorElement?.id && editorElement?.id}>
            <AddonTextWithIcon text={text} icon={icon} />
        </span>
    ) as HTMLElement;

    EditorAddonUtils.appendToInputGroup(editorElement, addon, before);
    return addon;
}

registerClass(InputGroupTextAddon, 'Serenity.InputGroupTextAddon');